import request from "@/utils/request";
export function join(user) {
  return request({
    url: "/auth/join",
    method: "post",
    data: { ...user },
  });
}

export function overseasJoin(user) {
  return request({
    url: "/auth/overseas_join",
    method: "post",
    data: { ...user },
  });
}

export function login(user) {
  return request({
    url: "/auth/login",
    method: "post",
    data: { ...user },
  });
}
export function wechatLogin(params) {
  return request({
    url: "/auth/wechat",
    params,
  });
}
export function qqLogin(params) {
  return request({
    url: "/auth/qq",
    params,
  });
}
export function wechatJoin(data) {
  return request({
    url: "/auth/wechat/join",
    method: "post",
    data,
  });
}
export function snsToken(params) {
  return request({
    url: "/auth/sns/token",
    params,
  });
}
export function qqJoin(data) {
  return request({
    url: "/auth/qq/join",
    method: "post",
    data,
  });
}

export function info() {
  return request({
    url: "/auth/info",
    method: "get",
  });
}
export function content(params) {
  return request({
    url: "/auth/content",
    method: "get",
    params,
  });
}
export function userInfo() {
  return request({
    url: "/auth/userInfo",
    method: "get",
  });
}
export function getUser(params) {
  return request({
    url: "/auth/user",
    method: "get",
    params,
  });
}

export function uploadTemp(data) {
  return request({
    url: "/auth/uploadFile",
    method: "post",
    data,
  });
}

export function uploadAvatar(data) {
  return request({
    url: "/auth/uploadFile",
    method: "post",
    data,
  });
}

export function getPm(params) {
  return request({
    url: "/private_message/get_my_pm_page",
    method: "get",
    params,
  });
}
export function getPmCotent(params) {
  return request({
    url: "/private_message/get_pm_page",
    method: "get",
    params,
  });
}
export function getPmUnread(params) {
  return request({
    url: "/private_message/unread_private_message_status",
    method: "get",
    params,
  });
}
export function getUserByNickname(params) {
  return request({
    url: "/auth/get_user_by_nickname",
    method: "get",
    params,
  });
}
export function updateNickname(params) {
  return request({
    url: "auth/edit_nickname",
    method: "put",
    params,
  });
}
export function updateInfo(params) {
  return request({
    url: "/auth/edit_user_info",
    method: "put",
    data: params,
  });
}

export function verifyCheck(params) {
  return request({
    url: "/verify/check",
    method: "post",
    data: params,
  });
}
export function verifyCheckCode(params) {
  return request({
    url: "/verify/check_verify_code",
    method: "post",
    data: params,
  });
}
export function cancelPhoneVerify() {
  return request({
    url: "/auth/unbind_phone_verify_status",
    method: "put",
  
  });
}
export function checkEmailVerify(params) {
  return request({
    url: "/verify/check_email_verify_code",
    method: "put",
    data:params,
  });
}








export function savePmCotent(params) {
  return request({
    url: "/private_message/save",
    method: "post",
    data: params,
  });
}

export function exist(id) {
  return request({
    url: "/auth/exist",
    method: "post",
    params: { id },
  });
}


export function editPassword(params) {
  return request({
    url: "auth/edit_password",
    method: "put",
    data: params,
  });
}